import React from 'react';
import './LegalTermsPopup.css'; // Import CSS for styling

interface LegalTermsPopupProps {
  content: string;
  onClose: () => void;
}

const LegalTermsPopup: React.FC<LegalTermsPopupProps> = ({ content, onClose }) => {
  return (
    <div className="legal-terms-popup-overlay">
      <div className="legal-terms-popup-content">
        <button className="close-button" onClick={onClose}>
          X
        </button>
        <div className="terms-content" dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </div>
  );
};

export default LegalTermsPopup;